var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("router-link", { attrs: { to: { name: "home" } } }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("subscriptionAnnounce.backToTop"))),
            ]),
          ]),
          _c(
            "a",
            {
              staticClass: "price-change",
              attrs: {
                href: "https://note.com/nolanovel/n/nd06fc46fa34c",
                target: "_blank",
              },
            },
            [
              _c("error-icon", { staticClass: "caution" }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("subscriptionAnnounce.priceChangeLink"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "title-section" }, [
        _c("div", { staticClass: "title-section-text" }, [
          _c("span", { staticClass: "premium-title" }, [
            _vm._v(_vm._s(_vm.$t("subscriptionAnnounce.premiumTitle"))),
          ]),
          _c("br"),
          _c("span", {
            staticClass: "premium-description",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("subscriptionAnnounce.premiumDescription")
              ),
            },
          }),
        ]),
        _c("img", {
          staticClass: "guide-img",
          attrs: {
            src: require("@/assets/img/premium/guide.png"),
            alt: "guide",
          },
        }),
      ]),
      _c("div", { staticClass: "announcement section" }, [
        _c("div", {
          staticClass: "description",
          domProps: {
            innerHTML: _vm._s(_vm.$t("subscriptionAnnounce.description")),
          },
        }),
        _c("div", { staticClass: "transition-register" }, [
          _c(
            "a",
            {
              staticClass: "button-design register",
              on: { click: _vm.onClickTransitionPlanSelection },
            },
            [_vm._v(_vm._s(_vm.$t("subscriptionAnnounce.checkFeaturesButton")))]
          ),
        ]),
      ]),
      _c("div", { staticClass: "feature-list" }, [
        _c(
          "div",
          { staticClass: "feature-content" },
          [
            _c("div", { staticClass: "feature-title" }, [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(_vm._s(_vm.$t("subscriptionAnnounce.recommendedTitle"))),
              ]),
            ]),
            _vm._l(_vm.recommends, function (recommend, index) {
              return _c(
                "div",
                { key: "recommend" + index, staticClass: "feature-item" },
                [
                  recommend.image.url
                    ? _c("img", {
                        attrs: {
                          src: _vm.optimizedImage(recommend.image.url),
                          loading: "lazy",
                          width: recommend.image.width,
                          height: recommend.image.height,
                        },
                      })
                    : _vm._e(),
                  _c("div", {
                    domProps: { innerHTML: _vm._s(recommend.html) },
                  }),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _c("div", { attrs: { id: "plan" } }),
      _c("div", { staticClass: "feature-table section" }, [
        _c("div", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_vm.$t("subscriptionAnnounce.featureTableTitle"))),
        ]),
        _vm.guideTableImageUrl
          ? _c("img", {
              attrs: {
                src: _vm.optimizedImage(_vm.guideTableImageUrl),
                loading: "lazy",
              },
            })
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "section-premium" },
        [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("subscriptionAnnounce.premiumSectionTitle"))),
          ]),
          _c("div", { staticClass: "section-title-small" }, [
            _vm._v(
              _vm._s(_vm.$t("subscriptionAnnounce.premiumSectionSubtitle"))
            ),
          ]),
          !_vm.hasPaymentError
            ? [
                _c("div", { staticClass: "plan-cards" }, [
                  _c(
                    "div",
                    {
                      staticClass: "plan-card",
                      on: {
                        click: function ($event) {
                          return _vm.selectPlan("monthly")
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "plan-radio" }, [
                        _c("div", {
                          staticClass: "radio-button",
                          class: { checked: _vm.selectedPlan === "monthly" },
                        }),
                      ]),
                      _c("div", { staticClass: "plan-content" }, [
                        _c("div", { staticClass: "plan-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("subscriptionAnnounce.monthlyPlanName")
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "plan-price" }, [
                          _vm._v(
                            _vm._s(_vm.$t("subscriptionAnnounce.monthlyPrice"))
                          ),
                          _c("span", { staticClass: "period" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("subscriptionAnnounce.monthlyPeriod")
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "plan-card yearly",
                      on: {
                        click: function ($event) {
                          return _vm.selectPlan("yearly")
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "plan-radio" }, [
                        _c("div", {
                          staticClass: "radio-button",
                          class: { checked: _vm.selectedPlan === "yearly" },
                        }),
                      ]),
                      _c("div", { staticClass: "plan-content" }, [
                        _c("div", { staticClass: "plan-name yearly" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("subscriptionAnnounce.yearlyPlanName")
                              ) +
                              " "
                          ),
                          _c("div", { staticClass: "plan-savings" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("subscriptionAnnounce.yearlySavings")
                              )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "plan-pricing" }, [
                          _c("div", { staticClass: "plan-price" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("subscriptionAnnounce.yearlyPriceLabel")
                              )
                            ),
                            _c("span", { staticClass: "price" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("subscriptionAnnounce.yearlyPrice")
                                )
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "plan-monthly" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "subscriptionAnnounce.yearlyMonthlyPrice"
                                )
                              )
                            ),
                            _c("span", { staticClass: "period" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("subscriptionAnnounce.monthlyPeriod")
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "plan-trial-info" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("subscriptionAnnounce.trialInfo"))),
                  ]),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "trial-button",
                    attrs: { disabled: _vm.isAlreadySubscribed },
                    on: { click: _vm.onClickStartTrial },
                  },
                  [
                    _c("div", { staticClass: "trial-text" }, [
                      _vm._v(_vm._s(_vm.buttonText)),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "message" }, [
                  _c("a", { attrs: { href: "/membership", target: "blank" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("subscriptionAnnounce.membershipLinkText"))
                    ),
                  ]),
                  _vm._v(
                    _vm._s(_vm.$t("subscriptionAnnounce.messageConnector"))
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/specifiedCommercialTransactionsAct",
                        target: "blank",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("subscriptionAnnounce.commercialLawLinkText")
                        )
                      ),
                    ]
                  ),
                  _vm._v(
                    _vm._s(_vm.$t("subscriptionAnnounce.messageSuffix")) + " "
                  ),
                ]),
              ]
            : [_c("PaymentDescription")],
        ],
        2
      ),
      _c("site-footer", { staticClass: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }